import '../AccessibilityStatement.css';
import React from 'react';
import AppHeader from './AppHeader';
import { useLanguage } from '../LanguageContext';
import { getTranslation } from '../consts/translations';

const AccessibilityStatement = () => {
  const { language } = useLanguage();
  const translation = getTranslation(language);

  const paragraphLines = translation.accessibility_paragraph_4.split('\n');

  return (
    <div className='accessibility-container'>
      <div className='status-background-image' />
      <AppHeader subtitle={translation.accessibility_statement_subtitle} height='224px' />
      <div className='accessibility-statement'>
        <div style={{ textDecoration: 'underline' }}>{translation.accessibility_text_1}</div>
        <br />
        <p>{translation.accessibility_paragraph_1}</p>
        <p>{translation.accessibility_paragraph_2}</p>
        <div className='accessibility-statement-subheader'>
          {translation.accessibility_subheader_1}
        </div>
        <p>{translation.accessibility_paragraph_3}</p>
        <div className='accessibility-statement-subheader'>
          {translation.accessibility_subheader_2}
        </div>
        <p>
          {paragraphLines.map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
        <div className='accessibility-statement-subheader'>
          {translation.accessibility_subheader_3}
        </div>
        <p>
          {translation.accessibility_paragraph_5}
          <br />
          <a href='mailto:acmg.support@psifas.org.il'>acmg.support@psifas.org.il</a>
          <br />
          {translation.accessibility_paragraph_6}
        </p>
        <div className='accessibility-statement-subheader'>
          {translation.accessibility_subheader_4}
        </div>
        <p>
          {translation.accessibility_paragraph_7}
          <br />
          {translation.accessibility_hebrew_label}
          <a href='https://www.isoc.org.il/files/w3c-wai/guidelines.html'>
            {translation.accessibility_hebrew_link_text}
          </a>
          <br />
          {translation.accessibility_english_label}
          <a href='http://www.w3.org/TR/WCAG20'>{translation.accessibility_english_link_text}</a>
        </p>
      </div>
    </div>
  );
};

export default AccessibilityStatement;
